import { render, staticRenderFns } from "./DirectorySwitcherDialog.vue?vue&type=template&id=4a74e933&"
import script from "./DirectorySwitcherDialog.vue?vue&type=script&lang=js&"
export * from "./DirectorySwitcherDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports